import { IConfig } from "../../shared/interfaces/interface-config";

const config: IConfig = {
    isAllowedMultistore: false,
    isEncryptData: true,
    isNewLayoutChosePayment: true,
    isShowEmailStore: true,
    isOldCard: false,
    isAllowedMaps: true,
    minimumHoursOffSetShippingSchedule: (window as any).globalConfig?.MINIMUM_HOURS_OFFSET || 3,
    roundingType: 1, // 0 = ABNT, 1 = RoundHalfUp
    email: 'fernando@conectogoferdinando.com.br',
    color: {
        background: "#f9f9f9",
        primary: "#da6022",
        primary_dark: "#ce5a21",
        primary_light: "#ff7028",
        menu: {
            background: "#fff",
            borderTopColor: "none",
            height: "40px"
        },
        navbar: {
            bg: "#672d90",
            color: "#ffffff",
            hover: "#a0465a"
        }
    },
    logo: require('../assets/conectogo-logo.png'),
    logo_alert_message: require('../assets/conectogo-logo.png'),
    image: {
        width: '200',
    }
}

export default config;